import { FormCard, FormItem } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { useAbilityAccess } from 'components/AccessControl'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'
import { useQueryClient } from 'react-query'
import EditableProfilePictureContainer from '../../../components/EditableProfilePictureContainer'

const EditProfilePicture = () => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)
  const queryClient = useQueryClient()
  const canEdit = useAbilityAccess([{ i: 'update', this: 'Resident' }])

  return (
    <FormCard>
      <FormItem label={<Text>{t(supConstants.PROFILE_PICTURE)}</Text>}>
        <EditableProfilePictureContainer
          disabled={!canEdit}
          queryClient={queryClient}
        />
      </FormItem>
    </FormCard>
  )
}

export default EditProfilePicture
